"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AdminList',
  components: {
    Pagination: _Pagination.default,
    // eslint-disable-next-line vue/no-unused-components
    selPlat: _selPlat.default,
    // eslint-disable-next-line vue/no-unused-components
    drawer: _filter.default
  },
  data: function data() {
    return {
      adminId: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      sysDialog: false,
      sysInfo: {},
      rolesName: [{
        'value': 'general',
        'name': '普通管理员'
      }, {
        'value': 'super',
        'name': '超级管理员'
      }]
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      var url = 'agentapi/getSysConfig';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start === 0) _this.tableMaxH = window.innerHeight - _this.$refs.order_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getEditSys: function getEditSys(row) {
      var _this2 = this;
      this.sysDialog = true;
      var sys_id = row.id;
      this.sys_id = row.id;
      var url = 'agentapi/editSysConfig';
      this.$post(url, {
        'sys_id': sys_id
      }).then(function (res) {
        _this2.sysInfo = res;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 设置权限
     */
    submitSysConfig: function submitSysConfig() {
      var _this3 = this;
      var params = this.sysInfo;
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/submitSysConfig', params).then(function (res) {
        _this3.loadObj.close();
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
        _this3.sysDialog = false;
        _this3.getList();
      }).catch(function () {
        _this3.loadObj.close();
      });
    }
  }
};